import { useState } from "react";
import { Modal, ModalTitle, ModalContent, ModalActions, Button, Table, TableHead, TableRow, TableCell, TableBody, TextField, IconButton, TableFooter, Typography } from "@deere/fuel-react";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import { ReactComponent as CheckIcon } from "@deere/ux.brand-foundations/icons/check.svg";

const ModalAddParts = ({ showModal, setShowModal, labelBtnPrimary, labelBtnSecondary, titleModal, saveSupplier, parts, setParts }) => {
  const [newPart, setNewPart] = useState({ id: "", partNumber: "", partDescription: "", hsCode: "" });
  const [error, setError] = useState({ show: false, message: "" });

  const changeHandler = (e) => {
    setError({ show: false, message: "" });
    const id = newPart.id === "" ? generateRandomId() : newPart.id;
    if (e.target.name === "partNumber") {
      setNewPart((prevState) => {
        return { ...prevState, partNumber: e.target.value, id: id };
      });
    } else if (e.target.name === "partDescription") {
      setNewPart((prevState) => {
        return { ...prevState, partDescription: e.target.value, id: id };
      });
    } else {
      setNewPart((prevState) => {
        return { ...prevState, hsCode: e.target.value, id: id };
      });
    }
  };

  const addHandler = () => {
    const partIndex = parts.findIndex((p) => p.partNumber === newPart.partNumber);
    if (partIndex > -1) {
      setError({ show: true, message: "Part already exists" });
    } else if (newPart.partNumber === "") {
      setError({ show: true, message: "Part Number is mandatory." });
    } else if (newPart.partDescription === "") {
      setError({ show: true, message: "Part Description is mandatory." });
    } else {
      setParts((prevState) => {
        return [...prevState, newPart];
      });
      setNewPart({ id: "", partNumber: "", partDescription: "", hsCode: "" });
    }
  };

  const deleteHandler = (id) => {
    const index = parts.findIndex((p) => p.id === id);
    if (index > -1) {
      setParts((prevState) => {
        prevState.splice(index, 1);
        return [...prevState];
      });
    }
  };

  const saveHandler = () => {
    if (parts.length === 0) {
      setError({ show: true, message: "Add Parts to proceed with Save." });
    } else {
      setNewPart({ id: "", partNumber: "", partDescription: "", hsCode: "" });
      setError({ show: false, message: "" });
      saveSupplier();
    }
  };

  const generateRandomId = () => {
    let random = Math.floor(Math.random() * 10000) + 1;
    const index = parts.findIndex((part) => part.id === random);
    if (index === -1) return random;
    else assignIfUniqueID();
  };

  const resetAllStates = () => {
    setParts([]);
    setNewPart({ id: "", partNumber: "", partDescription: "", hsCode: "" });
    setError({ show: false, message: "" });
  };

  const closeModal = () => {
    resetAllStates();
    setShowModal(false);
  };

  return (
    <Modal open={showModal} showClose={false}>
      <ModalTitle>{titleModal}</ModalTitle>
      <ModalContent dividers>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Part Number</TableCell>
              <TableCell>Part Description</TableCell>
              <TableCell>HS Code</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parts.map((part) => (
              <TableRow key={part.id}>
                <TableCell>{part.partNumber}</TableCell>
                <TableCell>{part.partDescription}</TableCell>
                <TableCell>{part.hsCode}</TableCell>
                <TableCell>
                  <IconButton>
                    <DeleteIcon onClick={() => deleteHandler(part.id)} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell>
                <TextField name="partNumber" onChange={changeHandler} value={newPart.partNumber} />
              </TableCell>
              <TableCell>
                <TextField name="partDescription" onChange={changeHandler} value={newPart.partDescription} />
              </TableCell>
              <TableCell>
                <TextField name="hsCode" onChange={changeHandler} value={newPart.hsCode} />
              </TableCell>
              <TableCell>
                <IconButton>
                  <CheckIcon onClick={addHandler} />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
        {error.show && (
          <Typography component="div" style={{ color: "red", fontSize: "smaller" }}>
            {error.message}
          </Typography>
        )}
      </ModalContent>
      <ModalActions>
        <Button variant="secondary" onClick={closeModal}>
          {labelBtnSecondary}
        </Button>
        <Button type="submit" variant="primary" onClick={saveHandler}>
          {labelBtnPrimary}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default ModalAddParts;
